import React from "react";

export default class extends React.Component {

    render() {
        return <div className="row">
            <div className="col-12">
                <div className="pubhub-smartsheet-form-divider"></div>
            </div>
        </div>

    }
}